import { object } from '@calendly/form/validation'

import { formatEventLinkValues, getEventLinkInitialValue, getEventLinkValidationSchema } from 'components/event_type_edit'

export const getInitialValues = (eventType) => {
  const { isShared } = eventType

  if (isShared) return {}

  return {
    ...getEventLinkInitialValue(eventType),
  }
}

export const getFormatValuesToServerData = (eventType) => (values) => {
  const { isShared } = eventType

  if (isShared) return {}

  return formatEventLinkValues(values)
}

export const getValidationSchema = (eventType) => {
  const { isShared } = eventType

  if (isShared) return object({})

  return getEventLinkValidationSchema()
}
